import rulesMixin from '@/mixins/input-rules';
import get from 'lodash/get';
import { mapState } from 'vuex';
export default {
  name: 'UpsertDashboardDialog',
  mixins: [rulesMixin],
  props: {
    value: {
      type: Boolean,
      required: true
    },
    dashboard: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      name: '',
      tenantId: null,
      parentDtwinId: null,
      formValid: false,
      isSaving: false
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled'])
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.name = get(this.dashboard, 'meta.name', '');
        this.parentDtwinId = get(this.dashboard, 'meta.parentDtwinId', null);
        this.tenantId = get(this.dashboard, 'identifier.tenantId', null);
      }
    }
  },
  methods: {
    async save() {
      this.$refs.form.validate();
      if (!this.formValid) {
        return;
      }
      this.isSaving = true;
      let result;
      if (this.dashboard) {
        result = await this.$store.dispatch('dashboards/changeDashboardConfig', {
          dashboardId: this.dashboard.id,
          name: this.name
          // parentDtwinId: this.parentDtwinId,
          // tenantId: this.tenantId,
        });
      } else {
        result = await this.$store.dispatch('dashboards/create', {
          name: this.name,
          parentDtwinId: this.parentDtwinId,
          tenantId: this.tenantId
        });
      }
      this.isSaving = false;
      if (!result.success) {
        console.error(result.error);
        this.$snack(this.$t('Dashboards.components.upsertDashboardDialog.errors.save', {
          error: result.error
        }), 'error');
        return;
      }
      this.$emit('save', result.dashboard);
    }
  }
};